import { useCallback, useMemo } from 'react';

import { MedicineSimple } from '@dreryk/drerykweb-medicine-api';

import { commonTranslationKeys, createTranslatedText, Translate } from '@dreryk/react-common';
import { Select, StyledFlex } from '@dreryk/react-components';

import { getSortedPreciseDosageUnits, PreciseDosageUnit, setPreferredDosageUnit } from '~libs.shared.prescription';
import { MedicineSinglePackageUnit } from '~libs.shared.medicine';

import { prescriptionTranslationKeys } from '../../../../../../../translations';
import { ExtendedDosageFormController } from '../ExtendedDosageForm.types';

const PORTION_UNIT_SELECT_WIDTH = '180px';

const triggerLabelExtractor = (selectedItem: string): string => selectedItem;

type PortionUnitSelectProps = Pick<ExtendedDosageFormController, 'register'> & {
   readonly defaultValue: string | null;
   readonly medicine: MedicineSimple;
};

export const PortionUnitSelect = (props: PortionUnitSelectProps): JSX.Element => {
   const items = useMemo(() => getSortedPreciseDosageUnits(props.medicine), [props.medicine]);

   const handleItemSelect = useCallback(
      (item: PreciseDosageUnit | MedicineSinglePackageUnit | null) => {
         if (item) {
            setPreferredDosageUnit(props.medicine, item);
         }
      },
      [props.medicine]
   );

   return (
      <StyledFlex direction={'row'} alignItems={'center'} gap={'6px'}>
         <Translate>{prescriptionTranslationKeys.extendedDosage.portionUnit}</Translate>
         <Select<PreciseDosageUnit | MedicineSinglePackageUnit>
            triggerLabelExtractor={triggerLabelExtractor}
            testId={'portionUnit'}
            placeholder={commonTranslationKeys.choose}
            controller={props.register('portionUnit', { required: true })}
            defaultValue={props.defaultValue}
            onSelect={handleItemSelect}
            width={PORTION_UNIT_SELECT_WIDTH}
            compact
         >
            <Select.List<string> items={items}>
               {(unit: string) => (
                  <Select.Item item={unit} testId={unit} key={unit} label={createTranslatedText(unit)} />
               )}
            </Select.List>
         </Select>
      </StyledFlex>
   );
};
